import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth, maxWidth } from '#/theme/theme';

import { CmsBodyHolderWidth } from './CmsBodyHolderWidth';

const gutterWidthVar = '--cms-body-holder-gutter-width';

const StyledCmsBodyHolder = styled.div`
  width: 100%;
  margin: 0 auto;

  ${gutterWidthVar}: ${gutterWidth / 2}px;

  @media screen and (min-width: ${cssBreakpoints.lgUp}) {
    ${gutterWidthVar}: ${gutterWidth}px;
  }

  &[data-width='${CmsBodyHolderWidth.NARROW_LAYOUT}'] {
    max-width: calc(740px + var(${gutterWidthVar}) * 2);
    padding: 0 var(${gutterWidthVar});
  }

  &[data-width='${CmsBodyHolderWidth.NARROW_LAYOUT_WIDE}'] {
    max-width: calc(952px + var(${gutterWidthVar}) * 2);
    padding: 0 var(${gutterWidthVar});
  }

  &[data-width='${CmsBodyHolderWidth.PAGE_LAYOUT}'] {
    padding: 0 var(${gutterWidthVar});

    @media screen and (min-width: ${cssBreakpoints.mdUp}) {
      max-width: ${maxWidth[2]}px;
    }

    @media screen and (min-width: ${cssBreakpoints.lgUp}) {
      max-width: ${maxWidth[3]}px;
    }
  }
`;

type Props = {
  holderWidth: CmsBodyHolderWidth;
  children: ReactNode;
};

export function CmsBodyHolder({ holderWidth, children }: Props) {
  return (
    <StyledCmsBodyHolder data-width={holderWidth}>
      {children}
    </StyledCmsBodyHolder>
  );
}
